import React from 'react'
import Loadable from 'react-loadable'
import LoadingIndicator from '../Common/components/LoadingIndicator/LoadingIndicator'


const routes = [
    {
        path: '/resetPassword',
        component: Loadable({
            loader: () => import('./components/ResetPassword/ResetPassword'),
            loading: () => (<LoadingIndicator/>)
        })
    },
    {
        path: '/signInForget',
        component: Loadable({
            loader: () => import('./components/SigninForget/SigninForget'),
            loading: () => (<LoadingIndicator/>)
        })
    },

    {
        path: '/resetPasswordDone',
        component: Loadable({
            loader: () => import('./components/ResetDone/ResetDone'),
            loading: () => (<LoadingIndicator/>)
        })
    },

    {
        path: '/linkExpired',
        component: Loadable({
            loader: () => import('./components/LinkExpired/LinkExpired'),
            loading: () => (<LoadingIndicator/>)
        })
    },

]

export default routes